import { useEffect, useRef } from 'react';

import { useLayer } from '../../LayerContext/useLayer';

type LayerValue = string | null;

export function useMapShortcuts(
  shortcutScopeRef: React.RefObject<HTMLElement>
) {
  const { layer, setLayer } = useLayer();
  const currentLayerRef = useRef<LayerValue>(layer);
  const previousLayerRef = useRef<LayerValue | undefined>(undefined);

  useEffect(() => {
    if (layer === currentLayerRef.current) {
      return;
    }

    previousLayerRef.current = currentLayerRef.current;
    currentLayerRef.current = layer;
  }, [layer]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        event.defaultPrevented ||
        event.repeat ||
        event.isComposing ||
        event.ctrlKey ||
        event.metaKey ||
        event.altKey ||
        event.shiftKey ||
        event.key.toLowerCase() !== 'l'
      ) {
        return;
      }

      const target = event.target;

      if (
        !(target instanceof HTMLElement) ||
        !shortcutScopeRef.current?.contains(target) ||
        target.matches('input, textarea, select') ||
        target.isContentEditable
      ) {
        return;
      }

      const previousLayer = previousLayerRef.current;
      if (previousLayer === undefined) {
        return;
      }

      event.preventDefault();

      previousLayerRef.current = currentLayerRef.current;
      currentLayerRef.current = previousLayer;
      setLayer(previousLayer);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [setLayer, shortcutScopeRef]);
}
